<mat-spinner *ngIf="loading" style="margin:0 auto;"></mat-spinner>

<div *ngIf="!loading">

    <h1>{{nodeId ? 'Edit' : 'Add'}} {{levelName}}</h1>
    <form [formGroup]="nodeForm" (submit)="submit()" fxLayout="column" fxLayoutGap="0.5rem">

        <mat-form-field>
            <mat-label>Title</mat-label>
            <input formControlName="label" name="label" matInput placeholder="Title" required>
        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="1rem">
            <button type="button" color="primary" mat-stroked-button (click)="cancel()">Cancel</button>
            <button type="submit" color="primary" mat-flat-button>{{nodeId ? 'Edit' : 'Add'}} {{levelName}}</button>
        </div>

    </form>
</div>